import { render, staticRenderFns } from "./case-batch-delete.vue?vue&type=template&id=3f6ae570"
import script from "./case-batch-delete.vue?vue&type=script&lang=ts"
export * from "./case-batch-delete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports